import { Box } from "@mui/material";

const ItemIcon = ({ height = 24, width = 24, color = "#657482", sx = {} }) => {
  return (
    <Box sx={sx}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 3.3252V7.3252C14 7.59041 14.1054 7.84477 14.2929 8.0323C14.4804 8.21984 14.7348 8.3252 15 8.3252H19M14 3.3252H7C6.46957 3.3252 5.96086 3.53591 5.58579 3.91098C5.21071 4.28605 5 4.79476 5 5.3252V19.3252C5 19.8556 5.21071 20.3643 5.58579 20.7394C5.96086 21.1145 6.46957 21.3252 7 21.3252H17C17.5304 21.3252 18.0391 21.1145 18.4142 20.7394C18.7893 20.3643 19 19.8556 19 19.3252V8.3252M14 3.3252L19 8.3252M8 15.3252H16M11 11.3252V18.3252M8 11.3252H16V18.3252H8V11.3252Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default ItemIcon;
